import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { MyRouterContext } from '@/App';
import * as Sentry from '@sentry/react';
import { FallbackComponent } from '@/components/FallbackComponent';

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <Sentry.ErrorBoundary
      fallback={<FallbackComponent />}
      showDialog={!!import.meta.env.VITE_SENTRY_SHOW_DIALOG}
    >
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </Sentry.ErrorBoundary>
  ),
});
